"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VNode = exports.VNodeMeta = void 0;
var tslib_1 = require("tslib");
var web_utility_1 = require("web-utility");
var VNodeMeta = /** @class */ (function () {
    function VNodeMeta() {
        this.children = [];
    }
    return VNodeMeta;
}());
exports.VNodeMeta = VNodeMeta;
var VNode = /** @class */ (function (_super) {
    tslib_1.__extends(VNode, _super);
    function VNode(_b) {
        var e_1, _c, _d, e_2, _e;
        var _this = this;
        var children = _b.children, meta = tslib_1.__rest(_b, ["children"]);
        _this = _super.call(this) || this;
        Object.assign(_this, meta);
        try {
            for (var _f = tslib_1.__values(children || []), _g = _f.next(); !_g.done; _g = _f.next()) {
                var vNode = _g.value;
                (_d = _this.children).push.apply(_d, tslib_1.__spreadArray([], tslib_1.__read((_a.isFragment(vNode) ? vNode.children || [] : [vNode])), false));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _h = tslib_1.__values(_this.children), _j = _h.next(); !_j.done; _j = _h.next()) {
                var child = _j.value;
                child.parent = _this;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_e = _h.return)) _e.call(_h);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is)
            return _this;
        _this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, '.')),
            is && "[is=\"".concat(is, "\"]")
        ]
            .filter(Boolean)
            .join('');
        return _this;
    }
    VNode.prototype.walkUp = function () {
        var current;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    current = this;
                    _b.label = 1;
                case 1:
                    if (!(current = current.parent)) return [3 /*break*/, 3];
                    return [4 /*yield*/, current];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    };
    VNode.prototype.namespaceOf = function (tagName) {
        var e_3, _b;
        if (web_utility_1.XMLNamespace[tagName])
            return web_utility_1.XMLNamespace[tagName];
        try {
            for (var _c = tslib_1.__values(this.walkUp()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var namespace = _d.value.namespace;
                if (namespace)
                    return namespace;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return web_utility_1.XMLNamespace.html;
    };
    VNode.prototype.createDOM = function (document) {
        if (document === void 0) { document = globalThis.document; }
        var _b = this, tagName = _b.tagName, is = _b.is, text = _b.text;
        return (this.node = text
            ? document.createTextNode(text)
            : !tagName
                ? document.createDocumentFragment()
                : document.createElementNS((this.namespace || (this.namespace = this.namespaceOf(tagName))), tagName, {
                    is: is
                }));
    };
    VNode.prototype.toJSON = function () {
        var _b = this, key = _b.key, text = _b.text, selector = _b.selector, namespace = _b.namespace, tagName = _b.tagName, is = _b.is, props = _b.props, style = _b.style, children = _b.children;
        return JSON.parse(JSON.stringify({ key: key, text: text, selector: selector, namespace: namespace, tagName: tagName, is: is, props: props, style: style, children: children }));
    };
    VNode.isFragment = function (_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = tslib_1.__rest(_b, ["key", "node", "children"]);
        for (var key_1 in rest)
            if (!(0, web_utility_1.isEmpty)(rest[key_1]))
                return false;
        return true;
    };
    VNode.fromDOM = function (node) {
        var _this = this;
        if (node instanceof Text)
            return new _a({ node: node, text: node.nodeValue });
        if (!(node instanceof Element))
            return new _a({ node: node });
        var _b = node, namespaceURI = _b.namespaceURI, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            namespace: namespaceURI,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute('is')
        };
        var props = Array.from(attributes, function (_b) {
            var name = _b.name, value = _b.value;
            return name !== 'style' && [_this.attrsMap[name] || name, value];
        }).filter(Boolean);
        if (props[0])
            vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function (key) { return [key, style[key]]; });
        if (styles[0])
            vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function (node) { return _a.fromDOM(node); });
        if (children[0])
            vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        className: 'class',
        htmlFor: 'for'
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function (item) { return item.reverse(); }));
    return VNode;
}(VNodeMeta));
exports.VNode = VNode;
